export default __webpack_public_path__ + "static/media/bdHome.42f8a5cd.png";